import * as React from "react";
import { forwardRef } from "react";
const SvgAddFieldsSort = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 14, viewBox: "0 0 20 14", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.5 4H0.5V6H11.5V4ZM11.5 0H0.5V2H11.5V0ZM15.5 8V4H13.5V8H9.5V10H13.5V14H15.5V10H19.5V8H15.5ZM0.5 10H7.5V8H0.5V10Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgAddFieldsSort);
export { ForwardRef as ReactComponent };
